// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared full-screen "document" overlay shell (.doc-overlay / .screen.doc /
   .doc__body). Used by the feedback overlay and any other full-screen sheet. */

.doc-overlay {
  position: fixed;
  inset: 0;
  z-index: 100;
  background: var(--palette-bg);
  overflow-y: auto;
}
.doc {
  overflow: visible;
}

.doc__body {
  padding: 0 var(--pad) calc(env(safe-area-inset-bottom, 0px) + 24px);
}
.doc__body p {
  color: var(--palette-text);
  line-height: 1.55;
  margin: 0 0 14px;
}
`, "",{"version":3,"sources":["webpack://./src/screens/components/docOverlay.css"],"names":[],"mappings":"AAAA;+EAC+E;;AAE/E;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,mEAAmE;AACrE;AACA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":["/* Shared full-screen \"document\" overlay shell (.doc-overlay / .screen.doc /\n   .doc__body). Used by the feedback overlay and any other full-screen sheet. */\n\n.doc-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 100;\n  background: var(--palette-bg);\n  overflow-y: auto;\n}\n.doc {\n  overflow: visible;\n}\n\n.doc__body {\n  padding: 0 var(--pad) calc(env(safe-area-inset-bottom, 0px) + 24px);\n}\n.doc__body p {\n  color: var(--palette-text);\n  line-height: 1.55;\n  margin: 0 0 14px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
